import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './our-campaigns-item.component.scss';
var OurCampaignsItem = /** @class */ (function (_super) {
    tslib_1.__extends(OurCampaignsItem, _super);
    function OurCampaignsItem(element) {
        return _super.call(this, element) || this;
    }
    OurCampaignsItem.prototype.init = function () { };
    ;
    OurCampaignsItem.prototype.bindEvents = function () { };
    ;
    return OurCampaignsItem;
}(Base));
export { OurCampaignsItem };



//////////////////
// WEBPACK FOOTER
// ./components/our-campaigns-item/our-campaigns-item.component.ts
// module id = 427
// module chunks = 0